import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import "./earning.css";
import { COLOR_MAP, BREAKDOWN_LABELS } from '../../../../shared/constants/EarningsPayout';
import { getTotalEarningsBreakdown } from "../../../../shared/actions/transactionAction";
import PieChart from "../../../../features/chart/PieChart";
import { ROLE } from "../../../../shared/constants/common";
import { formatUsdAmountDisplayCents } from "../../../../shared/utils/function";


const EarningsBreakdownCard = ({
    user
}) => {
    const [isShow, setIsShow] = useState(true);
    const [earningsData, setEarningsData] = useState([]);
    const toggleShow = () => setIsShow(!isShow);

    // Map category names to colors
    const getCategoryColor = (category) => {
        return COLOR_MAP[category] || "#6B7280"; // default gray
    };

    const getDisplayCategoryLabel = (category) => {
        if (category === 'Voice & Video Calls') return BREAKDOWN_LABELS.VOICE_VIDEO_CALLS;
        if (category === 'Message Purchases') return BREAKDOWN_LABELS.MESSAGE_PURCHASES;
        if (category === 'Content Purchases') return BREAKDOWN_LABELS.CONTENT_PURCHASES;
        return category;
    };

    const shouldHideDescription = user?.rol === ROLE.CREATOR_SUB || user?.rol === ROLE.CREATOR_CONTENT;

    useEffect(() => {
        if (user) {
            const fetchTotalEarningsBreakdown = async () => {
                const result = await getTotalEarningsBreakdown();
                if (result.success && result.data && result.data.breakdown) {
                    // Transform API data to match the component's expected format
                    const transformedData = result.data.breakdown
                        .map((item) => ({
                            label: getDisplayCategoryLabel(item.category),
                            subLabel: item.description,
                            amount: item.amount || 0,
                            percentage: item.percentage || 0,
                            color: getCategoryColor(getDisplayCategoryLabel(item.category))
                        }))
                        .filter((item) => {
                            // If user role is 1, exclude Content Purchases
                            if (user?.rol === ROLE.CREATOR_SUB && item.label === BREAKDOWN_LABELS.CONTENT_PURCHASES) {
                                return false;
                            }
                            // If user role is 3, exclude Subscriptions
                            if (user?.rol === ROLE.CREATOR_CONTENT && item.label === BREAKDOWN_LABELS.SUBSCRIPTIONS) {
                                return false;
                            }
                            return true;
                        });

                    setEarningsData(transformedData);
                }
            };

            fetchTotalEarningsBreakdown();
        }
    }, [user]);

    return (
        <div className={`g_card ${isShow ? '' : 'card_close'}`}>
            <div className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">
                    <i className='fa-solid fa-chart-pie'></i>
                    Earnings Breakdown
                </h3>
                {earningsData.length > 0 && (
                    <span onClick={toggleShow} className="cm_toggle_card">
                        <FontAwesomeIcon icon={isShow ? faAngleDown : faAngleUp} />
                    </span>
                )}
            </div>

            {isShow && earningsData.length > 0 && (
                <>
                    <div className='cm_hr_full'></div>
                    <PieChart
                        data={earningsData}
                        size={220}
                        strokeWidth={35}
                    />
                    <ul className="payouts_list">
                        {earningsData.map((item) => (
                            <li key={item.label}>
                                <div className="d-flex gap-3 align-items-center">
                                    <div>
                                        <span
                                            className="cm_label_color"
                                            style={{ background: item.color }}
                                        ></span>
                                    </div>
                                    <div>
                                        <p className="font_14 text-white">{item.label}</p>
                                        {!shouldHideDescription && <p>{item.subLabel}</p>}
                                    </div>
                                </div>
                                <div className="text-right">
                                    <h4>${formatUsdAmountDisplayCents(item.amount)}</h4>
                                    <p>{item.percentage}%</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
};

export default EarningsBreakdownCard;